import React from 'react';
import { Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { DEFAULT_RESULTS_TRANSLATION } from '../../../constants/results';

const useStyles = makeStyles(() => ({
  responded: {
    fontWeight: 500,
    fontSize: 12,
    textAlign: 'center',
    color: '#4F4F4F',
    margin: '0 0 5px 0',
  },
  answered: {
    fontWeight: 'bold',
    fontSize: 18,
    textAlign: 'center',
    color: '#333333',
    margin: 0,
  },
  outOf: {
    fontWeight: 'bold',
    fontSize: 11,
    textAlign: 'center',
    color: '#333333',
    margin: 0,
  },
}));

export default function ResponseRateText({
  totalAnswered,
  totalRespondents,
  attributesTitle,
  translation = DEFAULT_RESULTS_TRANSLATION,
}) {
  const classes = useStyles();

  const renderText = () => (
    <div className={classes.totalRespondentsText}>
      <p className={classes.responded}>{translation.responded}</p>
      <p className={classes.answered}>{totalAnswered}</p>
      <p className={classes.outOf}>{`${translation.outOf.toLowerCase()} ${totalRespondents}`}</p>
    </div>
  );

  if (!attributesTitle) return renderText();

  return <Tooltip title={attributesTitle}>{renderText()}</Tooltip>;
}
